import { Heading, VFlow } from 'bold-ui'
import { PageLoading } from 'components/loading'
import {
  useDispositivosPareadosUnidadeSaudeQuery,
  usePermissaoPainelChamadasQuery,
  useSalasUnidadeSaudeQuery,
} from 'graphql/hooks.generated'
import { emptyArrayOf } from 'util/array'

import { DispositivoPainelChamadaRow, PermissaoPainelChamadas, SalaPainelChamadaRow } from '../model-chamadaPainel'
import { CadastrarDispositivoPainelChamadasBox } from './components/CadastrarDispositivoPainelChamadasBox'
import { CadastrarSalaPainelChamadasBox } from './components/CadastrarSalaPainelChamadasBox'
import { HabilitarPainelChamadasBox } from './components/HabilitarPainelChamadasBox'

interface ConfiguracaoPainelChamadasViewProps {
  unidadeSaudeId: ID
}

export const ConfiguracaoPainelChamadasView = (props: ConfiguracaoPainelChamadasViewProps) => {
  const { unidadeSaudeId } = props

  const {
    data: dataDispositivosPareados,
    loading: loadingDispositivosPareados,
    refetch: refetchDispositivosPareados,
  } = useDispositivosPareadosUnidadeSaudeQuery({
    variables: { unidadeSaudeId },
  })

  const { data: dataSalas, loading: loadingSalas, refetch: refetchSalasUnidadeSaude } = useSalasUnidadeSaudeQuery({
    variables: { unidadeSaudeId },
  })

  const { data: dataPermissao, loading: loadingPermissao } = usePermissaoPainelChamadasQuery({
    variables: { unidadeSaudeId },
  })

  const isButtonHabilitarDisabled =
    (dataSalas?.salasUnidadeSaude?.isEmpty() ||
      dataDispositivosPareados?.dispositivosPareadosUnidadeSaude?.isEmpty()) ??
    true

  const permissaoGql = dataPermissao?.unidadeSaude?.actions?.permissaoPainelChamadas
  const permissao: PermissaoPainelChamadas = {
    enabled: permissaoGql?.enabled ?? false,
    hint: permissaoGql?.hint ?? null,
  }

  if (loadingPermissao) {
    return <PageLoading message='Carregando...' />
  }

  return (
    <VFlow vSpacing={0.5}>
      <Heading level={2}>Configurar painel de chamadas da unidade</Heading>
      <HabilitarPainelChamadasBox
        unidadeSaudeId={unidadeSaudeId}
        isButtonDisabled={isButtonHabilitarDisabled}
        permissao={permissao}
      />
      <CadastrarDispositivoPainelChamadasBox
        dispositivosPareados={
          dataDispositivosPareados?.dispositivosPareadosUnidadeSaude ?? emptyArrayOf<DispositivoPainelChamadaRow>()
        }
        loadingDispositivosPareados={loadingDispositivosPareados}
        unidadeSaudeId={unidadeSaudeId}
        onCreate={refetchDispositivosPareados}
        onDelete={refetchDispositivosPareados}
        permissao={permissao}
      />
      <Heading level={2}>Cadastrar salas</Heading>
      <CadastrarSalaPainelChamadasBox
        salas={dataSalas?.salasUnidadeSaude ?? emptyArrayOf<SalaPainelChamadaRow>()}
        loadingSalas={loadingSalas}
        unidadeSaudeId={unidadeSaudeId}
        onCreate={refetchSalasUnidadeSaude}
        onDelete={refetchSalasUnidadeSaude}
        permissao={permissao}
      />
    </VFlow>
  )
}
